import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./plugins/i18n";
import { initAndroidBridge } from "./services/androidBridge";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";

initAndroidBridge();

var app = createApp(App);

app.use(i18n);
app.use(router);
app.use(store);

app.mount("#app");
